export default ({ request }) => ({
  fabricInspectionListApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/list',
      method: 'post',
      data,
    })
  },
  fabricInspectionDetailApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/detail',
      method: 'post',
      data,
    })
  },
  fabricInspectionDelApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/del',
      method: 'post',
      data,
    })
  },
  fabricInspectionSaveApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/save',
      method: 'post',
      data,
    })
  },
  fabricInspectioRegisterApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/pc/register',
      method: 'post',
      data,
    })
  },
  fabricInspectioSubmitInspectionApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/submitInspection',
      method: 'post',
      data,
    })
  },
  fabricInspectionSubmitApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/submit',
      method: 'post',
      data,
    })
  },
  fabricInspectionAuditApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/audit',
      method: 'post',
      data,
    })
  },
  fabricInspectionRejectApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/reject',
      method: 'post',
      data,
    })
  },
  fabricInspectionRollbackApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/rollback',
      method: 'post',
      data,
    })
  },
  inspectionDefectIssuesListApi(data = {}) {
    return request({
      url: '/factory/inspection/defectIssues/list',
      method: 'post',
      data,
    })
  },
  inspectionDefectImageListApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/image/list',
      method: 'post',
      data,
    })
  },
  inspectionDefectImageSaveApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/image/save',
      method: 'post',
      data,
    })
  },
  inspectionDefectImageDelApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/image/del',
      method: 'post',
      data,
    })
  },

  
  fabricInspectionDetailListApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/detail/list',
      method: 'post',
      data,
    })
  },
  fabricInspectionDetailInfoApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/detail/detail',
      method: 'post',
      data,
    })
  },
  fabricInspectionDetailSaveApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/detail/save',
      method: 'post',
      data,
    })
  },
  fabricInspectionDetailDelApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/detail/del',
      method: 'post',
      data,
    })
  },
  fabricInspectionDetailBatchDelApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/detail/batchDel',
      method: 'post',
      data,
    })
  },
  fabricInspectionDefectListApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/defect/list',
      method: 'post',
      data,
    })
  },
  fabricInspectionDefectSaveApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/defect/save',
      method: 'post',
      data,
    })
  },
  fabricInspectionDefectDelApi(data = {}) {
    return request({
      url: '/factory/fabric/inspection/defect/del',
      method: 'post',
      data,
    })
  },
})
